import styled from "styled-components";

export const CardHeader = styled.div`
  display: flex;
`;

export const CardFooter = styled.div`
  margin-left: 40px;
`;
